module.exports = __webpack_public_path__ + "static/media/node1.3de51675.jpg";